import request from "@/utils/interceptor.js";

const courseApi = {
  // 课程列表
  getList(params) {
    return request({
      url: `/api/pas/course`,
      method: "get",
      params,
    });
  },
  addCourse(data) {
    return request({
      url: `/api/pas/course`,
      method: "post",
      data,
    });
  },
  editCourse(data) {
    return request({
      url: `/api/pas/course/${data.id}`,
      method: "put",
      data,
    });
  },
  delCourse(id) {
    return request({
      url: `/api/pas/course/${id}`,
      method: "delete",
    });
  },

  // 课程章节列表
  getCourseList(params) {
    return request({
      url: `/api/pas/course-list`,
      method: "get",
      params,
    });
  },
  addCourseList(data) {
    return request({
      url: `/api/pas/course-list`,
      method: "post",
      data,
    });
  },
  editCourseList(data) {
    return request({
      url: `/api/pas/course-list/${data.id}`,
      method: "put",
      data,
    });
  },
  delCourseList(id) {
    return request({
      url: `/api/pas/course-list/${id}`,
      method: "delete",
    });
  },

  // 绑定视频id
  bindVideo(data) {
    return request({
      url: `/api/pas/video-library`,
      method: "post",
      data,
    });
  }
};

export default courseApi;
